import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@pwc/pwc-deals-ui';
import { Route } from 'react-router-dom';

import './SurveyWelcomeModal.scss';
import { useSelector } from 'react-redux';
import { getSurveyResponses } from '../../surveySlice';
import { surveyRoute } from '../../routes';

const SurveyWelcomeModal = () => {
  const [show, setShow] = useState(true);
  const surveyResponses = useSelector(getSurveyResponses);
  const [questionBasedText, setQuestionBasedText] = useState('');

  useEffect(() => {
    if (surveyResponses) {
      if (surveyResponses.answers.length) {
        setQuestionBasedText('Continue Questionnaire');
      } else {
        setQuestionBasedText('Start Questionnaire');
      }
    }
  }, [surveyResponses]);

  return (
    <Route path={surveyRoute}>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        dialogClassName="survey-welcome-modal"
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Title>
          <h1>Welcome,</h1>
        </Modal.Title>
        <Modal.Body>
          The Diagnostic Questionnaire is the first step of a divestiture
          deal&apos;s process, which creates a holistic business overview ahead
          of a deal.
          <br />
          <br />
          This questionnaire is intelligent and will update to fit your unique
          scenario. It should take you around 10 minutes to complete.
          <br />
          <br />
          The completed questionnaire will provide us with an overview of
          Financial and Operations with a series of cross functional layers
          underneath them that help to understand business performance,
          regulatory requirements, and how entangled it is with the rest of the
          company.
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setShow(false);
            }}
          >
            {questionBasedText}
          </Button>
        </Modal.Footer>
      </Modal>
    </Route>
  );
};

export default SurveyWelcomeModal;
